module.exports = __webpack_public_path__ + "img/og-image.e6438c0c.jpeg";